import { BURIAL_COUNTRIES, BURIAL_LOCATIONS, BurialCountryCode } from '../../data/burial-locations'

const DATALIST_ID = 'burial-location-options'

interface BurialPreferenceInputProps {
  country: BurialCountryCode
  location: string
  onCountryChange: (country: BurialCountryCode) => void
  onLocationChange: (value: string) => void
  onBlur?: () => void
  error?: string
}

export default function BurialPreferenceInput({
  country,
  location,
  onCountryChange,
  onLocationChange,
  onBlur,
  error,
}: BurialPreferenceInputProps) {
  const suggestions = BURIAL_LOCATIONS[country] ?? []

  const handleCountryChange = (next: BurialCountryCode) => {
    // Switching country clears a picked cemetery from the other country's
    // list; typed custom text is left alone.
    const knownElsewhere = (BURIAL_LOCATIONS[country] ?? []).some((opt) => opt.value === location)
    onCountryChange(next)
    if (knownElsewhere) onLocationChange('')
  }

  return (
    <div>
      <label htmlFor="preferredBurialCountry" className="block text-sm font-medium text-gray-700">
        Burial Country
      </label>
      <select
        id="preferredBurialCountry"
        value={country}
        onChange={(e) => handleCountryChange(e.target.value as BurialCountryCode)}
        className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 focus:border-emerald-500 focus:ring-emerald-500"
      >
        {BURIAL_COUNTRIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.label}
          </option>
        ))}
      </select>

      <label htmlFor="preferredBurialLocation" className="mt-3 block text-sm font-medium text-gray-700">
        Burial Location
      </label>
      <input
        id="preferredBurialLocation"
        list={DATALIST_ID}
        type="text"
        value={location}
        onChange={(e) => onLocationChange(e.target.value)}
        onBlur={onBlur}
        placeholder="Type or select a preferred cemetery / burial area"
        autoComplete="off"
        className={`mt-1 block w-full rounded-md border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 ${
          error
            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-emerald-500 focus:ring-emerald-500'
        }`}
      />
      <datalist id={DATALIST_ID}>
        {suggestions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </datalist>
      <p className="mt-1 text-xs text-gray-500">
        Specify preferred cemetery or burial location in case of passing. Used for advance planning only.
      </p>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  )
}
